import { createFileRoute } from '@tanstack/react-router';
import { McpTenantFeaturesPage } from '@/features/admin/pages/mcp';

export const Route = createFileRoute('/admin/mcp/tenants')({
  component: McpTenantFeaturesPage,
});
